import { Component, OnInit, ViewChild, ChangeDetectorRef } from "@angular/core";
import { Router } from "@angular/router";
import { UserService } from "app/core/service/user.service";
import { User } from "app/core/domain/user";
import { ConfirmationService } from "primeng/components/common/api";
import { GlobalAppService } from "../../../core/commons/global-app.service";
import { MessageSeverity } from "../../../core/commons/message-severity";
import { AuthService } from "../../../core/security/auth.service";
import { ServerPaginationStore } from "app/core/commons/server-pagination-store";
import { Observable } from "rxjs/Observable";
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { LazyLoadEvent } from "primeng/primeng";
import { QueryOptions } from "../../../core/commons/query.options";
import { PaginationPage } from "../../../core/commons/pagination-page";
import { MatPaginator, MatSort, MatTableDataSource } from "@angular/material";
import { FormGroup, FormBuilder, FormControl } from "@angular/forms";

@Component({
  selector: "app-user",
  templateUrl: "./user-list.component.html",
  styleUrls: ["./user-list.component.scss"],
  providers: [UserService]
})
export class UserListComponent implements OnInit {
  @ViewChild("paginator") paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  displayedColumns = ["lastname", "firstname", "email", "activado", "acciones"];
  userInID = -1;
  data = new MatTableDataSource([]);
  queryOptions: QueryOptions;
  resultsLength: number;
  formGroup: FormGroup;

  constructor(
    public userService: UserService,
    private confirmationService: ConfirmationService,
    private router: Router,
    private appService: GlobalAppService,
    private authService: AuthService,
    private fb: FormBuilder
  ) {}

  ngOnInit() {
    this.authService.user.subscribe(u => (this.userInID = u.id));

    this.formGroup = this.fb.group({
      search: new FormControl(""),
      enabled: new FormControl("true")
    });

    this.queryOptions = new QueryOptions();
    this.queryOptions.size = 5;
    this.applyFilter();

    this.paginator.page.subscribe(() => {
      this.queryOptions.page = this.paginator.pageIndex;
      this.queryOptions.size = this.paginator.pageSize;
      this.applyFilter();
    });

    this.formGroup.controls["search"].valueChanges
      .debounceTime(400)
      .subscribe(() => this.applyFilterAndReset());
    this.formGroup.controls["enabled"].valueChanges.subscribe(() =>
      this.applyFilterAndReset()
    );
  }

  applyFilter() {
    this.userService
      .pagedSearch(
        this.formGroup.controls["search"].value,
        this.formGroup.controls["enabled"].value,
        this.queryOptions
      )
      .subscribe(data => {
        this.data.data = data.content;
        // this.data =
        this.resultsLength = data.totalElements;
      });
  }

  applyFilterAndReset() {
    // Reset paginator
    this.paginator.pageIndex = 0;
    // Reset query options
    this.queryOptions.size = 5;
    this.queryOptions.page = 0;
    this.applyFilter();
  }

  public gotoDetail(user: User) {
    this.router.navigate(["home", "users", user.id]);
  }

  public addUser() {
    this.router.navigate(["home", "users", "new"]);
  }

  public updateUser(user: User, event) {
    if (user.id !== this.userInID) {
      this.confirmationService.confirm({
        message: "Está seguro que desea cambiar el valor?",
        icon: "fa ui-icon-warning",
        accept: () => {
          this.appService.setLoading(true);
          this.userService.update(user).subscribe(() => {
            this.applyFilter();
            this.appService.setLoading(false);
          });
        },
        reject: () => {
          user.enabled = !user.enabled;
        }
      });
    }
  }

  public deleteUser(user: User) {
    this.confirmationService.confirm({
      message: "¿Está seguro que desea eliminar el usuario?",
      icon: "fa ui-icon-delete-forever",
      accept: () => {
        this.appService.setLoading(true);
        this.userService.delete(user).subscribe(
          b => {
            this.appService.setLoading(false);
            this.applyFilter();
            this.appService.sendMsg(
              MessageSeverity.SUCCESS,
              "Eliminado",
              "Se ha eliminado el usuario."
            );
          },
          error => {
            user.enabled = false;
            this.userService.update(user).subscribe(() => {
              this.applyFilter();
              this.appService.setLoading(false);
            });
            this.appService.sendMsg(
              MessageSeverity.SUCCESS,
              "Eliminado",
              "Se ha eliminado el usuario (desactivado)."
            );
          }
        );
      }
    });
  }

  public resetPass(user: User) {
    this.confirmationService.confirm({
      message: `¿Está seguro que desea resetear la contraseña del usuario ${
        user.firstname
      } ${user.lastname}?`,
      icon: "fa ui-icon-warning",
      accept: () => {
        this.appService.setLoading(true);
        this.userService.resetPass(user).subscribe(
          user => {
            this.appService.setLoading(false);
            this.appService.sendMsg(
              MessageSeverity.SUCCESS,
              "Exito!",
              "Se ha reseteado la contraseña con éxito."
            );
          },
          error => {
            this.appService.setLoading(false);
            this.appService.sendMsg(
              MessageSeverity.ERROR,
              "Error",
              "No ha sido posible resetear la contraseña. " +
                error.json().message
            );
          }
        );
      }
    });
  }
}

class UserPageStore extends ServerPaginationStore<User> {
  private searchTerms: string = null;

  constructor(service: UserService, appService: GlobalAppService) {
    super(service, appService);
  }

  protected doQuery(qo: QueryOptions): Observable<PaginationPage<User>> {
    return (this.service as UserService).pagedSearch(
      this.searchTerms,
      "true",
      qo
    );
  }

  public updateFromOnLazyLoadEvent(event: LazyLoadEvent): void {
    this.searchTerms = event.globalFilter;
    super.updateFromOnLazyLoadEvent(event);
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/users/user-list/user-list.component.ts